import gql from 'graphql-tag';

export const CREATE_TRUST_MUTATION = gql`
  mutation createTrust($trustInputDetails: TrustInput!) {
    createTrust(trustInput: $trustInputDetails) {
      id
      testatorId
      name
      incorporationNumber
      displayName
      testamentaryTrust
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      specificDonations {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
    }
  }
`;

export const UPDATE_TRUST_MUTATION = gql`
  mutation updateTrust($id: ID!, $trustInputDetails: TrustInput!) {
    updateTrust(id: $id, trustInput: $trustInputDetails) {
      id
      testatorId
      name
      incorporationNumber
      distributionSpecificPercentage {
        id
      }
      distributionSpecificPercentageAlternatives {
        id
      }
      alternativeDistributionSpecificPercentage {
        id
      }
      specificDonations {
        id
      }
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
      }
    }
  }
`;

export const DELETE_TRUST_MUTATION = gql`
  mutation deleteTrust($id: ID!) {
    deleteTrust(id: $id) {
      id
    }
  }
`;
